import { axiosImageAPI } from '@/axios';

const uploadImage = (imageType = 'display-image', fileImage) => {
  const formData = new FormData();
  formData.append('file', fileImage);

  return axiosImageAPI.post(`/assets/${imageType}`, formData, {
    headers: { 'content-type': 'multipart/form-data' },
  });
};

const uploadPngImage = (imageType = 'logoImage', fileImage) => {
  const formData = new FormData();
  formData.append('file', fileImage);

  return axiosImageAPI.post(`/assets/${imageType}/png`, formData, {
    headers: { 'content-type': 'multipart/form-data' },
  });
};

export {
  uploadImage,
  uploadPngImage,
};
